import { useAppSelector } from 'app/hooks';
import DuctedPairSectionHeading from 'components/equipment-page/ducted-pair-section-heading';
import type { DuctedBundleSlot } from 'utils/ducted-bundle-picks-types';
import { selectDuctedPairExistingSystemLabel } from 'utils/ducted-design';

type DuctedRailSectionHeadingProps = Readonly<{
  systemUniqueId: string;
  bundleSlot: DuctedBundleSlot | null;
}>;

export default function DuctedRailSectionHeading({
  systemUniqueId,
  bundleSlot
}: DuctedRailSectionHeadingProps) {
  const systemName = useAppSelector((state) =>
    selectDuctedPairExistingSystemLabel(state, systemUniqueId)
  );
  if (bundleSlot) {
    return (
      <DuctedPairSectionHeading
        pairName={bundleSlot.pairName}
        coolingBtu={bundleSlot.context.loads.cooling}
        systemName={systemName}
      />
    );
  }
  if (systemName === null) return null;
  return (
    <div className='text-xs font-semibold uppercase tracking-wider text-gray-500'>
      {systemName}
    </div>
  );
}
